export default {"src":"/_next/static/media/window-design.5d001c1f.svg","height":25,"width":21,"blurWidth":0,"blurHeight":0};